import React from 'react';
import { List } from 'immutable';
import config from 'react-global-configuration';

import { CoreLink } from '@uncinc/react-drupal-core';
import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  DOMAIN_AMSTERDAMUNDERGROUND,
} from '../../../config/constants';

import './style.scss';

const ParagraphPartners = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed']);
  const partners = entity.getIn(['field_partners'], List());
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'], ''));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const currentDomainIsAmsterdamUnderground = config.get('CURRENT_DOMAIN') === DOMAIN_AMSTERDAMUNDERGROUND;

  return (
    <Container className="ParagraphPartners">
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <div className="ParagraphPartners__title">
            <h2 className={!currentDomainIsAmsterdamUnderground ? 'asH1' : ''}>{title}</h2>
          </div>

          <div className="ParagraphPartners__body">
            <WysiwygField
              property="schema:text"
              html={text}
            />
          </div>
        </div>

        <div className="col-12">
          <div className="ParagraphPartners__partners">
            <div className="row">
              {partners.map((partner) => {
                const uuid = partner.getIn(['entity', 'uuid', 0, 'value']);
                const image = partner.getIn(['entity', 'field_image', 0, 'styles', 'medium']);
                const link = partner.getIn(['entity', 'field_link', 0, 'title'], '');

                return (
                  <div key={uuid} className="col-6 col-md-3">
                    <CoreLink href={link}>
                      <Image
                        lazyload
                        includeWebP
                        src={image}
                      />
                    </CoreLink>
                  </div>
                );
              })}
            </div>
          </div>

          {linkUrl && (
            <div className="ParagraphPartners__link">
              <CoreLink className="Button Button--secondary" to={linkUrl}>
                {linkTitle}<i className="icon icon-arrow-right" />
              </CoreLink>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphPartners;
